import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ISAMLogoffInterceptor } from './ISAM-Logoff.interceptor';
import { AuthenticationInterceptor } from './authentication.interceptor';
import { CsrfInterceptor } from './csrf.interceptor';
import { ServerErrorsInterceptor } from './server-errors.interceptor';
import { StartStopInterceptor } from './startstop.interceptor';

export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: StartStopInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ISAMLogoffInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ServerErrorsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CsrfInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: ISAMSecureDeviceInterceptor, multi: true }
];
